import type {} from '@formatjs/icu-messageformat-parser';

export { messages } from './messages';
export const loadMessages = (locale: string) => import(`./${locale}.json`);
